// extracted by mini-css-extract-plugin
export default {"header":"AppLayout_header__88CcG","bottom":"AppLayout_bottom__H644I","layout":"AppLayout_layout__WY8n0"};